<template>
  <property-compare
    is-sample-view
    :comparable-addresses="sample.comparable_addresses"
    :subject="sample.subject"
    :report="sample"
  >
    <template #primay-button>
      <q-btn no-caps unelevated color="primary" :to="{ name: 'Subscribe to Property Reports' }">
        7-Day Free Trial
      </q-btn>
    </template>
  </property-compare>
</template>
<script lang="ts">
import { type PropType } from 'vue'
import PropertyCompare from '@/components/PropertyReports/PropertyCompare.vue'
import type { RentSourceSubscriptionAttributes } from 'common'

export default {
  name: 'PropertyReportsSample',
  components: { PropertyCompare },
  props: {
    sample: {
      required: true,
      type: Object as PropType<RentSourceSubscriptionAttributes>
    }
  }
}
</script>
